<div class="tooltip-host" [attr.data-tooltip]="text" [attr.data-position]="position">
    <ng-content></ng-content>
</div>